import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import ShowOnMouseOverCss from '../../../../cssSnippets/ShowOnMouseOverCss';

const ContainerPadding = css`
  padding: 24px 16px;
`;

const Block = styled.div`
  ${ContainerPadding}
  ${ShowOnMouseOverCss}
  overflow-x: hidden;
`;

const ContainerDiv = styled(motion.div)`
  background-color: var(--color-bg-muted);
  border: 1px solid var(--color-grey-8);
  border-radius: 6px;

  margin-bottom: 32px;

  position: relative;
  width: 100%;
`;

const GroupInputStyles = {
  Block,
  ContainerDiv,
};

export default GroupInputStyles;
